import {Button, ButtonGroup} from "@mui/material";
import {LogiCtrlRuleAction} from "../../../../../api/LogiCtrl";
import Refresh from "@mui/icons-material/Refresh";
import Send from "@mui/icons-material/Send";
import SkipNext from "@mui/icons-material/SkipNext";
import {grey} from "@mui/material/colors";

const inheritedSx = {
    backgroundColor: grey[200],
    color: grey[600],
    borderColor: grey[400],
    borderStyle: "dashed",
    "&:hover": { borderColor: grey[600], backgroundColor: grey[300], borderStyle: "dashed" },
};

export function LogiCtrlButtons(props: {
    value: LogiCtrlRuleAction;
    onChange(action: LogiCtrlRuleAction): void;
    inherited?: LogiCtrlRuleAction;
}) {
    function buttonProps(action: "skip" | "send" | "not-released-replace") {
        if (props.value === action) {
            return { variant: "contained" as const, sx: {} };
        }
        if (props.value === null && props.inherited === action) {
            return { variant: "outlined" as const, sx: inheritedSx };
        }
        return { variant: "outlined" as const, sx: {} };
    }

    const skip = buttonProps("skip");
    const send = buttonProps("send");
    const tryUpdate = buttonProps("not-released-replace");

    return (
        <ButtonGroup size="small" sx={{"& .MuiButton-root": {
                minWidth: 0, padding: "1px 6px", fontSize: 11, textTransform: "none", lineHeight: 1.4,
            }}}>
            <Button
                variant={skip.variant}
                onClick={() => props.onChange(props.value === "skip" ? null : "skip")}
                startIcon={<SkipNext sx={{fontSize: "14px !important"}} />}
                sx={skip.sx}
            >Skip</Button>
            <Button
                variant={tryUpdate.variant}
                onClick={() => props.onChange(props.value === "not-released-replace" ? null : "not-released-replace")}
                startIcon={<Refresh sx={{fontSize: "14px !important"}} />}
                sx={tryUpdate.sx}
            >Try Update</Button>
            <Button
                variant={send.variant}
                onClick={() => props.onChange(props.value === "send" ? null : "send")}
                startIcon={<Send sx={{fontSize: "14px !important"}} />}
                sx={send.sx}
            >Send</Button>
        </ButtonGroup>
    )
}